import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import {
  currentPlaybackItemDurationAtom,
  currentPlaybackTimeAtom,
  videoCanPlayAtom,
} from '../atoms/playback/playbackStatus';
import { emptyPlaylistAtom, selectedPlaylistAtom } from '../atoms/playlist';

export default function useClearPlaylist() {
  const setSelectedPlaylist = useSetAtom(selectedPlaylistAtom);
  const emptyPlaylist = useSetAtom(emptyPlaylistAtom);
  const setCurrentPlaybackItemDuration = useSetAtom(
    currentPlaybackItemDurationAtom,
  );
  const setCanPlay = useSetAtom(videoCanPlayAtom);
  const setCurrentPlaybackTime = useSetAtom(currentPlaybackTimeAtom);

  useEffect(() => {
    emptyPlaylist();
    setSelectedPlaylist();
    setCanPlay(false);
    setCurrentPlaybackItemDuration(0);
    setCurrentPlaybackTime(0);
  }, []);
}
